import { PRIMARY_COLORS_VARIANTS } from '@/utils/constants/colors'
import { Box } from '@mui/material'
import React from 'react'

export const BottomDrawerHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box px={2.5} pt={2.5} pb={1.5} bgcolor={PRIMARY_COLORS_VARIANTS[500]}>
      {children}
    </Box>
  )
}
